module.exports = __webpack_public_path__ + "static/media/noun-reject-1890961-142350.abe3a0ff.svg";